import { sendGet, sendGetHR } from '../helpers/axios';

export const apiGetListAssetsUser = (params) => sendGet(`/api/asset-user`, params);
export const apiGetListRequest = (params) => sendGet(`/api/asset/hr-request`, params);
export const apiRequestFifth = (ID) => sendGetHR(`/api/request/${ID}`);
export const apiCountAssetsUser = (params) => sendGet(`/api/count-asset-user`, params);
